export const DEFAULT_STORE_PROFILE_PICTURE = "/store.png";

const isAbsoluteUrl = (value) => /^(?:https?:|blob:|data:)/i.test(value);

export function getStoreProfilePictureUrl(profilePicture, cacheKey) {
  const picturePath =
    typeof profilePicture === "string" ? profilePicture.trim() : "";

  if (!picturePath) {
    return DEFAULT_STORE_PROFILE_PICTURE;
  }

  const baseUrl =
    process.env.REACT_APP_UPLOADS_URL ||
    process.env.REACT_APP_API_URL ||
    "";
  const pictureUrl = isAbsoluteUrl(picturePath)
    ? picturePath
    : `${baseUrl}${picturePath.startsWith("/") ? "" : "/"}${picturePath}`;

  if (!cacheKey || pictureUrl.startsWith("blob:") || pictureUrl.startsWith("data:")) {
    return pictureUrl;
  }

  const separator = pictureUrl.includes("?") ? "&" : "?";
  return `${pictureUrl}${separator}v=${encodeURIComponent(cacheKey)}`;
}

export function getAbsoluteStoreProfilePictureUrl(profilePicture, cacheKey) {
  const pictureUrl = getStoreProfilePictureUrl(profilePicture, cacheKey);

  if (isAbsoluteUrl(pictureUrl)) {
    return pictureUrl;
  }

  return new URL(pictureUrl, window.location.origin).href;
}
